import React from 'react';
import { AlertBanner, AlertBannerTypes } from '../../Components/AlertBanner';
import styles from './LmbcWarningBar.module.css';
export function LmbcWarningBar() {
    var prompt = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: styles.regular }, "This medication is on the "),
        React.createElement("span", { className: styles.veryStrongWords }, "List of Medicines for Brand Consideration (LMBC)."),
        React.createElement("span", { className: styles.regular }, " Consider prescribing by "),
        React.createElement("span", { className: styles.veryStrongWords }, "brand name"),
        React.createElement("span", { className: styles.regular }, " if clinically relevant.")));
    return (React.createElement(AlertBanner, { promptMessage: prompt, promptType: AlertBannerTypes.Warn, verticalSpace: true }));
}
